import { render, staticRenderFns } from "./InformationCards.vue?vue&type=template&id=56b0ba38&scoped=true"
import script from "./InformationCards.vue?vue&type=script&lang=js"
export * from "./InformationCards.vue?vue&type=script&lang=js"
import style0 from "./InformationCards.vue?vue&type=style&index=0&id=56b0ba38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0ba38",
  null
  
)

export default component.exports